import urlMapping from '@next-app/config/urlMapping';
import { makeFetchCall } from '@next-app/utils/fetch-data';
import { refetch } from '@next-app/utils/common-utils';

export const prepareGuestCheckout = async ({
  paypalCheckout,
  isPaypalFromCheckout,
  _dynSessConf,
  dispatch,
  isFurniture = false,
}: {
  paypalCheckout: boolean;
  isPaypalFromCheckout: boolean;
  _dynSessConf: number;
  dispatch: Function;
  isFurniture?: boolean;
}) => {
  let requestPayload = {
    endpoint: urlMapping.prepareGuestCheckout,
    options: {
      method: 'POST',
    },
    headers: {
      'Content-Type': 'application/json',
      'Is-Furniture': isFurniture ? 'true' : 'false',
    },
    body: {
      paypalCheckout,
      isPaypalFromCheckout,
      _dynSessConf,
    },
  };

  let response = await makeFetchCall(requestPayload);

  if (response?.code === 401) {
    response = await refetch({
      response: response,
      request: requestPayload,
      dispatch,
    });
  }
  return response;
};

export const applyPaypalCheckout = async ({
  useRegistryAddress,
  useCTLAddress,
  isPaypalFromCheckout,
  _dynSessConf,
  dispatch,
  isFurniture = false,
}: {
  useRegistryAddress: boolean;
  isPaypalFromCheckout: boolean;
  useCTLAddress?: boolean;
  _dynSessConf: number;
  dispatch: Function;
  isFurniture?: boolean;
}) => {
  const requestPayload = {
    endpoint: urlMapping.applyPayPalCheckout,
    options: {
      method: 'POST',
    },
    headers: {
      'Content-Type': 'application/json',
      'Is-Furniture': isFurniture ? 'true' : 'false',
    },
    body: {
      useRegistryAddress,
      useCTLAddress: useCTLAddress ?? false,
      isPaypalFromCheckout,
      _dynSessConf,
    },
  };

  let response = await makeFetchCall(requestPayload);

  if (response?.code === 401) {
    response = await refetch({
      response: response,
      request: requestPayload,
      dispatch,
    });
  }
  return response;
};
